



















import HalfModal from '@/components/molecules/HalfModal.vue'
import { OTHER_PRODUCTS_LINKS, OtherProductsLink } from '@hl-itemlist/model/other-products-links'
import Vue from 'vue'

export default Vue.extend({
  components: {
    HalfModal,
  },
  computed: {
    links(): ReadonlyArray<OtherProductsLink> {
      return OTHER_PRODUCTS_LINKS
    },
  },
})
